module.exports = __webpack_public_path__ + "static/assets/0b7320b18e9da9d0921e54f364e47fb8.png";